module.exports = __webpack_public_path__ + "assets/GoldOmega.84bf637cf26e4f5b417e3c6e04fb6604.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldOmega.png
// module id = 768
// module chunks = 0